import Button from '@mui/material/Button'
import {
    Box,
    Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { GetPersisterConfigFile, SelectRowFromTable } from '../universal/Axios';
import { getStore } from '../../Store' 
const store = getStore();

const EditPersisterConfig = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("id")
    const [persisterConfigFile, setPersisterConfigFile] = useState("")
    const [persisterConfigObject, setPersisterConfigObject] = useState("")


    const copyToClipboard = () => {
        navigator.clipboard.writeText(persisterConfigFile);
        store.updateSuccessMessage("Copied to clipboard!")
    }


    useEffect(() => {
        GetPersisterConfigFile(id, setPersisterConfigFile)
        SelectRowFromTable("select * from persister_config where id = '" + id + "';", setPersisterConfigObject)
    }, []);


    const UploadDensityNetworkConfigButton = () =>
        <Button
            sx={{ marginLeft: '20px' }}
            variant="contained"
            href={"upload-persister-config"}
        >
            Upload Persister Config
        </Button>
    if (persisterConfigFile === "") {
        return <div>Loading...</div>
    }
    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box>
                    <Typography variant="h6">{id}</Typography>
                </Box>
                <Box>
                    <UploadDensityNetworkConfigButton />
                </Box>
            </Box>
            <Box sx={{ m: 2 }}>
                {persisterConfigObject.description}
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-around", marginTop: '20px', fontSize: '20px' }}>
                <Box sx={{width: '33%', float: "left"}}></Box>
                <Box sx={{ width: '33%', textAlign: "center", margin: "auto", display: "inline-block", fontSize: '20px' }}>
                    <span sx={{ float: "right" }}><b>File Content:</b></span>
                </Box>
                <Box sx={{ width: '33%' }}>
                    <Button
                        onClick={() => copyToClipboard(persisterConfigFile)}
                        variant="contained"
                        sx={{ float: "right" }}
                    >
                        Copy to Clipboard
                    </Button>
                </Box>
            </Box>
            {persisterConfigFile === "" && <div>Loading...</div>}
            <Box sx={{ display: "flex", justifyContent: "center", marginTop: '20px' }}>
                <Box component="div" sx={{ border: 1, overflow: 'auto', width: '1000px', height: '500px' }}>
                    <pre>{persisterConfigFile}</pre>
                </Box>
            </Box>
        </Box>
    )
}

export default EditPersisterConfig